<template>
  <div class="pb-page narrow ai">
    <section class="pb-card ai-card" aria-labelledby="ai-title">
      <span class="pb-empty-icon" aria-hidden="true"><i :class="['mdi', done ? 'mdi-account-check-outline' : 'mdi-account-plus-outline']"></i></span>
      <h1 id="ai-title" class="pb-title display-font">{{ done ? 'You\'re in' : 'Join a TrustClap workspace' }}</h1>
      <p v-if="done" class="pb-body">You joined {{ done }}. You'll see the brands your teammate shared with you.</p>
      <p v-else-if="!token" class="pb-body">This invitation link is incomplete. Ask your teammate to send it again.</p>
      <p v-else class="pb-body">You were invited to help manage testimonials. You're signed in as <strong>{{ email }}</strong>; the invitation must be for this address.</p>
      <div v-if="error" class="pb-alert is-error" role="alert"><i class="mdi mdi-alert-circle-outline pb-ico" aria-hidden="true"></i><span>{{ error }}</span></div>
      <div class="pb-actions ai-actions">
        <router-link v-if="done" to="/" class="pb-button">Open the workspace</router-link>
        <button v-else-if="token" type="button" class="pb-button lg" :disabled="busy" @click="accept">{{ busy ? 'Joining…' : 'Accept invitation' }}</button>
        <router-link v-if="!done && error" to="/logout" class="pb-button ghost">Sign in with another address</router-link>
      </div>
    </section>
  </div>
</template>

<script>
import { post, message } from '../api';

export default {
  name: 'AcceptInviteView',
  data() { return { token: String(this.$route.query.token || ''), busy: false, error: '', done: '' }; },
  computed: { email() { const user = this.$store.getters.currentUser; return user ? user.email : ''; } },
  methods: {
    async accept() {
      this.busy = true;
      this.error = '';
      try {
        const result = await post('/members/accept', { token: this.token });
        this.done = result.workspace;
        this.$store.commit('praiseboard/BRAND', null);
        await this.$store.dispatch('praiseboard/load').catch(() => null);
      } catch (error) { this.error = message(error, 'This invitation is no longer valid. Ask for a new one.'); } finally { this.busy = false; }
    }
  }
};
</script>

<style scoped>
.ai-card{text-align:center;padding:44px 32px;margin-top:24px}
.ai-card .pb-body{max-width:460px;margin:12px auto 0}
.ai-actions{justify-content:center;margin-top:24px}
</style>
